module.exports = __webpack_public_path__ + "static/media/29ADMSPC24.52b67adb.jpg";